export default "__VITE_ASSET__deCwlsec__"